module.exports = "https://r.nearpod.com/assets/media/image/google-icon-58d0aefaa647909855daab438c770a59.svg";